/**
 * Alternative more user-friendly name than saying integration service.
 * @param type
 */
export function apiOrEvent(type: 'REST' | 'EVENT') {
  switch (type) {
    case 'REST': {
      return 'API';
    }
    case 'EVENT': {
      return 'event';
    }
  }
}
